<template>
  <div id="app">
    <div id="nav"></div>
    <router-view :key="$route.fullPath" />
  </div>
</template>

<script>
export default {
  mounted() {
    // console.log('navigator.onLine', navigator.onLine)
  },

  watch: {
    "navigator.onLine"() {
      // console.log("navigator", navigator);
      // console.log("navigator.onLine", navigator.onLine);
      // if (!navigator.onLine) {
      //     alert("인터넷 연결이 원할하지 않습니다.");
      //     localStorage.removeItem('userId')
      //     localStorage.removeItem('accessToken')
      //     delete this.axios.defaults.headers.common['accessToken']
      //     this.$router.push('/user/login')
      // }
    },
  },
};
</script>

<style>
/* #app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
} */
</style>
